module.exports = __webpack_public_path__ + "img/ocean-wave.68fb695b.jpg";